// Environment configuration
export const config = {
  supabase: {
    url: import.meta.env.VITE_SUPABASE_URL || '',
    anonKey: import.meta.env.VITE_SUPABASE_ANON_KEY || '',
  },
  api: {
    baseUrl: import.meta.env.VITE_API_URL || 'http://localhost:3000',
  },
  app: {
    name: 'Newsletter',
    url: import.meta.env.VITE_APP_URL || 'http://localhost:5173',
  },
  newsletter: {
    enabled: import.meta.env.VITE_NEWSLETTER_ONLY === 'true',
  },
} as const;

// Validate required environment variables in development
if (import.meta.env.DEV) {
  const missing: string[] = [];

  if (!config.supabase.url) missing.push('VITE_SUPABASE_URL');
  if (!config.supabase.anonKey) missing.push('VITE_SUPABASE_ANON_KEY');

  if (missing.length > 0) {
    console.warn(
      `[Config] Missing environment variables: ${missing.join(', ')}. ` +
        'Create a .env.local file with these values.',
    );
  }
}
